import Vue from 'vue'
import * as api from '@/api'
Vue.prototype.$api = api
